<template>
  <JContainer>
    <div class="py-8 md:pt-[11rem]">
      <ComplianceContentSkeleton v-if="isLoading" />

      <template v-else>
        <JBreadcrumb
          v-if="isDesktop"
          class="pb-16"
          :items="[{ label: 'TripMentor.com', url: '/' }, { label: pageTitle }]"
        />

        <!-- Page Title -->
        <h1
          v-if="isDesktop"
          class="text-gray-800 pb-16 text-greeting font-medium text-black"
        >
          {{ pageTitle }}
        </h1>

        <div v-if="!isDesktop" class="flex items-center">
          <TheMobileHeader
            showBack
            :showHelpIcon="false"
            titleClass="ps-16"
            :title="pageTitle"
            @back="$router.back()"
          />
        </div>

        <!-- Content -->
        <div class="rounded-md border border-gray-300 bg-white p-16">
          <div
            v-sanitize="sanitizeContent(content)"
            class="rich-text-content"
          ></div>
        </div>
      </template>
    </div>
  </JContainer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { JBreadcrumb, JContainer } from '@journey/ui-kit'
import { computed } from 'vue'
import { useCookiePolicyContentQuery } from '../requests/queries/useCookiePolicyContentQuery'
import ComplianceContentSkeleton from '../components/partials/ComplianceContentSkeleton/ComplianceContentSkeleton.vue'
import { useDevicePlatform } from '@/modules/Core/composables'
import TheMobileHeader from '@/modules/Core/components/layout/MobileHeader/TheMobileHeader.vue'
import { sanitizeContent } from '@/modules/Core/utils'

const { t } = useI18n()

const { isDesktop } = useDevicePlatform()

const { data, isLoading } = useCookiePolicyContentQuery()

const pageTitle = computed(() => data.value?.title || t('cookiePolicy'))

const content = computed(() => data.value?.description || '')
</script>
